import React from 'react'
import Link from 'src/components/link'
import Button from 'src/components/button'
import { useStore } from 'src/state'

const Footer = () => {
  const {
    footer: {
      nyFormId,
      nyButtonText,
      nyEmail,
      laFormId,
      laButtonText,
      laEmail,
      copyrightText,
      privacyButtonText,
      policiesButtonText,
      termsButtonText,
      careersButtonText,
      socials,
    },
    showFormOverlay,
    setFormOverlayId,
  } = useStore()

  return (
    <footer className="footer">
      <div className="row row-end">
        <div className="col col-start">
          <p className="copyright">{copyrightText}</p>
          <Link to={`/privacy-policy`}>{privacyButtonText}</Link>
          <Link to={`/policies`}>{policiesButtonText}</Link>
          <Link to={`/terms`}>{termsButtonText}</Link>
          {nyEmail ? (
            <Link to={`mailto:${nyEmail}`} newTab>
              {nyButtonText}
            </Link>
          ) : (
            <Button
              onClick={() => {
                setFormOverlayId(nyFormId)
                showFormOverlay()
              }}
            >
              <span>{nyButtonText}</span>
            </Button>
          )}
          {laEmail ? (
            <Link to={`mailto:${laEmail}`} newTab>
              {laButtonText}
            </Link>
          ) : (
            <Button
              onClick={() => {
                setFormOverlayId(laFormId)
                showFormOverlay()
              }}
            >
              <span>{laButtonText}</span>
            </Button>
          )}
          <Link to="/careers">{careersButtonText}</Link>
        </div>
        <div className="col col-end">
          {socials.map(({ id, title, url }) => (
            <Link key={id} to={url} newTab>
              {title}
            </Link>
          ))}
        </div>
      </div>
    </footer>
  )
}

export default Footer
